// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d830c7ee","350":"494bd98f","453":"c082cd20","732":"f942ebca","943":"22f381bd"}[chunkId] + ".chunk.js";
};